import React from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './main.css';


import background from './images/Section 1 - Background.png';

function Section1() {
    AOS.init();
    return (
        <section className="australia-council-section1-container">
            <h1 className="australia-council-section1-container-title" data-aos="fade-up" data-aos-delay="50" data-aos-duration="2000" data-aos-once="true">Ziplyne: Navigating Digital Transformation Down Under</h1>
            <img src={background} alt="" className="australia-council-section10-bg" />
            <div className="ac-section1-paragraph" data-aos="fade-down" data-aos-delay="100" data-aos-duration="2000" data-aos-once="true">
                <p > "<i>To thrive in the digital age, companies must undergo two distinct
                digital transformations. They must become digitized by incorporating
                digital technology into their core operations, like accounting and
                invoicing. They also need to be become digital, which means
                         developing a digital platform for the company’s digital offerings. </i>" </p>

                <div className="ac-section1-creds">
                    <div className="ac-section1-line">
                    </div> <i >MIT Sloan School of Management Report, March 2020</i></div>
            </div>
        </section>


    )
}

export default Section1
